module.exports = __webpack_public_path__ + "static/media/BwModelicaSS02-Bold.921b0cc8.otf";